export const SERVER_URL = "https://do-calculate.com/api";

export const mathCalculators_Fr = [
  // Existing Main Calculators
  {
    name: "Calculatrice de pourcentage",
    link: "/calculator/fr/percentage/",
    description:
      "Ce calculateur est utilisé pour calculer les pourcentages et les augmentations ou diminutions de pourcentage.",
    showMain: true,
  },
  {
    name: "Calculatrice de volume",
    link: "/calculator/fr/volumes/",
    description:
      "Cette calculatrice gratuite calcule les volumes de formes courantes incluant la sphère, le cône, le cube, le cylindre, la capsule, la calotte, le cône tronqué, l'ellipsoïde, la pyramide, le tube et bien d'autres.",
    showMain: true,
  },
  {
    name: "Calculatrice de racine",
    link: "/calculator/fr/roots/",
    description:
      "Cette calculatrice gratuite calcule les racines des nombres, y compris les racines courantes comme la racine carrée ou la racine cubique, et calcule la racine pour n'importe quel nombre donné.",
    showMain: true,
  },
  {
    name: "Calculatrice d'aire",
    link: "/calculator/fr/areas/",
    description:
      "Ce calculateur calcule l'aire de diverses formes géométriques courantes, y compris le rectangle, le triangle, le parallélogramme, le cercle, le secteur et l'ellipse.",
    showMain: true,
  },
  {
    name: "Calculatrice de rang médian",
    link: "/calculator/fr/median/",
    description:
      "La calculatrice de valeur médiane calcule le rang médian et explique comment le calculer.",
    showMain: true,
  },
  {
    name: "Calculatrice de circonférence du cylindre",
    link: "/calculator/fr/cylinder-circumference/",
    description:
      "La calculatrice de circonférence du cylindre calcule la circonférence d'un cylindre en fonction de son diamètre et de sa hauteur.",
    showMain: true,
  },
  {
    name: "Calculatrice d'aire du réservoir",
    link: "/calculator/fr/tank-area/",
    description:
      "La calculatrice d'aire du réservoir calcule l'aire d'un réservoir en fonction de ses dimensions et des rectangles qui le composent.",
    showMain: true,
  },
  {
    name: "Calculatrice du rayon du cercle",
    link: "/calculator/fr/circle-radius/",
    description:
      "La calculatrice du rayon du cercle calcule le rayon d'un cercle en utilisant des informations telles que le diamètre, la circonférence ou l'aire du cercle.",
    showMain: true,
  },

  // NEW MATH CALCULATORS (47)
  {
    name: "Calculatrice 5%",
    link: "/calculator/fr/5percent/",
    description:
      "Apprenez à calculer 5% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 5% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 10%",
    link: "/calculator/fr/10percent/",
    description:
      "Apprenez à calculer 10% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 10% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 15%",
    link: "/calculator/fr/15percent/",
    description:
      "Apprenez à calculer 15% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 15% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 20%",
    link: "/calculator/fr/20percent/",
    description:
      "Apprenez à calculer 20% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 20% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 25%",
    link: "/calculator/fr/25percent/",
    description:
      "Apprenez à calculer 25% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 25% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 30%",
    link: "/calculator/fr/30percent/",
    description:
      "Apprenez à calculer 30% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 30% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 35%",
    link: "/calculator/fr/35percent/",
    description:
      "Apprenez à calculer 35% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 35% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 40%",
    link: "/calculator/fr/40percent/",
    description:
      "Apprenez à calculer 40% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 40% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 45%",
    link: "/calculator/fr/45percent/",
    description:
      "Apprenez à calculer 45% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 45% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice 75%",
    link: "/calculator/fr/75percent/",
    description:
      "Apprenez à calculer 75% d'un montant. Ce calculateur calcule la valeur et le pourcentage de 75% d'un montant spécifique.",
    showMain: true,
  },
  {
    name: "Calculatrice du pourcentage d'absence",
    link: "/calculator/fr/absence-percentage/",
    description:
      "La calculatrice du pourcentage d'absence calcule le pourcentage d'absence en fonction de la présence totale et du nombre d'absences.",
    showMain: true,
  },
  {
    name: "Calculatrice du pourcentage de présence",
    link: "/calculator/fr/attendance-percentage/",
    description:
      "La calculatrice du pourcentage de présence calcule le pourcentage de présence en fonction de la présence totale et du nombre d'absences.",
    showMain: true,
  },
  {
    name: "Calculatrice du cercle",
    link: "/calculator/fr/circle-calculator/",
    description:
      "La calculatrice du cercle calcule le rayon, le diamètre, la circonférence et l'aire d'un cercle.",
    showMain: true,
  },
  {
    name: "Calculatrice de béton",
    link: "/calculator/fr/concrete-calculator/",
    description:
      "La calculatrice de béton calcule la quantité de béton nécessaire pour un projet spécifique.",
    showMain: false,
  },
  {
    name: "Calculatrice des facteurs",
    link: "/calculator/fr/factor-calculator/",
    description:
      "La calculatrice des facteurs trouve tous les facteurs d'un nombre donné.",
    showMain: true,
  },
  {
    name: "Calculatrice des fractions",
    link: "/calculator/fr/fractions-calculator/",
    description:
      "La calculatrice des fractions effectue des opérations sur les fractions avec étapes détaillées.",
    showMain: true,
  },
  {
    name: "Calculatrice du Plus Grand Commun Diviseur (PGCD)",
    link: "/calculator/fr/gcf-calculator/",
    description:
      "La calculatrice GCF trouve le plus grand commun diviseur de deux ou plusieurs nombres.",
    showMain: true,
  },
  {
    name: "Calculatrice du Plus Petit Commun Multiple (PPCM)",
    link: "/calculator/fr/lcm-calculator/",
    description:
      "La calculatrice LCM trouve le plus petit commun multiple de deux ou plusieurs nombres.",
    showMain: true,
  },
  {
    name: "Convertisseur de litres",
    link: "/calculator/fr/liter-converter/",
    description:
      "Le convertisseur de litres convertit entre litres et d'autres unités de volume.",
    showMain: true,
  },
  {
    name: "Calculatrice de division longue",
    link: "/calculator/fr/long-division-calculator/",
    description:
      "La calculatrice de division longue effectue la division longue avec étapes détaillées.",
    showMain: true,
  },
  {
    name: "Opérations sur les matrices",
    link: "/calculator/fr/matrix-operations/",
    description:
      "La calculatrice des matrices effectue des opérations sur les matrices comme l'addition, la soustraction et la multiplication.",
    showMain: false,
  },
  {
    name: "Calculatrice de médiane",
    link: "/calculator/fr/median-calculator/",
    description:
      "La calculatrice de médiane calcule la valeur médiane d'un ensemble de nombres.",
    showMain: true,
  },

  {
    name: "Calculatrice d'un cinquième",
    link: "/calculator/fr/one-fifth/",
    description:
      "La calculatrice d'un cinquième calcule un cinquième d'un montant total.",
    showMain: true,
  },
  {
    name: "Calculatrice d'un tiers",
    link: "/calculator/fr/one-third-calculator/",
    description:
      "La calculatrice d'un tiers calcule un tiers d'un montant total.",
    showMain: true,
  },
  {
    name: "Calculatrice de densité de population",
    link: "/calculator/fr/population-density/",
    description:
      "La calculatrice de densité de population calcule la densité de population en fonction du nombre de population et de la surface.",
    showMain: true,
  },
  {
    name: "Calculatrice de probabilité",
    link: "/calculator/fr/probability-calculator/",
    description:
      "La calculatrice de probabilité calcule les probabilités des événements.",
    showMain: true,
  },
  {
    name: "Calculatrice d'un quart",
    link: "/calculator/fr/quarter-calculator/",
    description:
      "La calculatrice d'un quart calcule un quart d'un montant total.",
    showMain: true,
  },
  {
    name: "Calculatrice du reste",
    link: "/calculator/fr/remainder-calculator/",
    description:
      "La calculatrice du reste calcule le reste d'une division.",
    showMain: true,
  },
  {
    name: "Calculatrice de racine",
    link: "/calculator/fr/root-calculator/",
    description:
      "La calculatrice de racine calcule la racine carrée, cubique ou n-ième d'un nombre.",
    showMain: true,
  },
  {
    name: "Calculatrice d'arrondi",
    link: "/calculator/fr/rounding-calculator/",
    description:
      "La calculatrice d'arrondi arrondit un nombre à un nombre spécifique de décimales ou de chiffres significatifs.",
    showMain: true,
  },
  {
    name: "Calculatrice de taille d'échantillon",
    link: "/calculator/fr/sample-size-calculator/",
    description:
      "La calculatrice de taille d'échantillon calcule la taille d'échantillon nécessaire pour une enquête statistique.",
    showMain: false,
  },
  {
    name: "Calculatrice de simplification de fractions",
    link: "/calculator/fr/simplifying-fractions-calculator/",
    description:
      "La calculatrice de simplification de fractions réduit une fraction à sa forme la plus simple.",
    showMain: true,
  },
  {
    name: "Calculatrice du volume d'une sphère (simple)",
    link: "/calculator/fr/sphere-volume/",
    description:
      "Calculatrice simple pour calculer le volume d'une sphère.",
    showMain: false,
  },
  {
    name: "Calculatrice du diamètre d'un carré",
    link: "/calculator/fr/square-diameter-calculator/",
    description:
      "La calculatrice du diamètre d'un carré calcule le diamètre d'un carré en fonction de sa diagonale.",
    showMain: false,
  },
  {
    name: "Calculatrice du carré",
    link: "/calculator/fr/squared-calculator/",
    description:
      "La calculatrice du carré élève un nombre au carré.",
    showMain: true,
  },
  {
    name: "Calculatrice de la longueur du côté d'un carré",
    link: "/calculator/fr/square-side-length/",
    description:
      "La calculatrice de la longueur du côté d'un carré calcule la longueur du côté d'un carré en fonction de l'aire.",
    showMain: true,
  },

  {
    name: "Calculatrice de la hauteur du trapèze",
    link: "/calculator/fr/trapezoid-height-calculator/",
    description:
      "La calculatrice de la hauteur du trapèze calcule la hauteur d'un trapèze.",
    showMain: true,
  },
  {
    name: "Calculatrice du triangle",
    link: "/calculator/fr/triangle-calculator/",
    description:
      "La calculatrice du triangle calcule l'aire et le périmètre d'un triangle.",
    showMain: true,
  },
  {
    name: "Calculatrice des angles du triangle",
    link: "/calculator/fr/triangle-angles-calculator/",
    description:
      "La calculatrice des angles du triangle calcule les angles d'un triangle.",
    showMain: true,
  },
  {
    name: "Calculatrice de l'hypoténuse du triangle",
    link: "/calculator/fr/triangle-hypotenuse-calculator/",
    description:
      "La calculatrice de l'hypoténuse du triangle calcule l'hypoténuse d'un triangle rectangle.",
    showMain: true,
  },
  {
    name: "Calculatrice de trigonométrie",
    link: "/calculator/fr/trigonometry-calculator/",
    description:
      "La calculatrice de trigonométrie calcule les fonctions trigonométriques sinus, cosinus et tangente.",
    showMain: true,
  },
  {
    name: "Calculatrice de deux tiers",
    link: "/calculator/fr/two-thirds-calculator/",
    description:
      "La calculatrice de deux tiers calcule deux tiers d'un montant total.",
    showMain: true,
  },
];
